import React, { Component } from 'react';
import './StreamingVideo.scss';
import Hls from "hls.js";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlayCircle, faPauseCircle } from '@fortawesome/free-solid-svg-icons';
import Images from '../Image/Image';
import { streamId, pattern } from '../../../services/subscriberService';
import { selectIcon } from '../selector';
import PropTypes from 'prop-types';
import { CheckValue } from '../../../services/CommonFunction';
// import { cache } from 'sw-toolbox';
// import caches from '';

// var caches;
class StreamingVideo extends Component {

    state = {
        status: true,
        showIcon: true,
        disable: true,
        vid: null,
        videoSrc: null,
        hls: new Hls(),
        version: '?v=1.0'
    }

    componentDidUpdate = async (nextProps) => {
        const src = this.checkSrc(nextProps.videoSrc);
        if (this.state.videoSrc !== src) {
            if (!this.state.status) {
                await this.videoControl();
            }
            setTimeout(async () => {
                await this.setState({ videoSrc: src })
                this.state.vid.load();
                setTimeout(() => {
                    this.setState({ disable: this.state.vid.readyState === 4 || src ? false : true })
                    this.videoHlr(src);
                }, 500);
            }, 200);
        }
    }

    checkSrc = (src) => {
        if (!CheckValue(src)) {
            return src;
        }
        return typeof src === 'string' ? src : src.value;
    }

    componentDidMount = async () => {
        await this.setState({ vid: document.getElementById(this.props.id) })
    }

    componentWillUnmount() {
        this.state.hls.destroy();
        this.setState({
            vid: null,
            videoSrc: null,
            hls: null
        })
        if (streamId.detail === this.props.id) {
            streamId.sendData('');
        }
    }

    videoHlr = async (videoSrc, close = false) => {
        const obj = new RegExp(pattern.streamUrl);
        if (Hls.isSupported() && obj.test(videoSrc)) {
            const { hls, version } = this.state;
            const video = this.props.addVersion ? videoSrc : videoSrc + version;
            hls.attachMedia(this.state.vid);
            hls.on(Hls.Events.MEDIA_ATTACHED, function () {
                hls.loadSource(video);
                hls.on(Hls.Events.MANIFEST_PARSED, function () {
                    if (!this.props.show) {
                        hls.startLoad(1);
                        this.state.vid.play();
                    }
                });
            });

            hls.on(Hls.Events.LEVEL_LOADED, function (event, data) { });
            // hls.startLoad(1)
        } else if (this.state.vid.canPlayType('application/vnd.apple.mpegurl')) {
            this.state.vid.addEventListener('loadedmetadata', function () {
                //  video.play();
            });
        }
    }

    videoControl = () => {
        if (this.state.vid.readyState !== 0) {
            if (this.state.status) {
                if (streamId.detail !== '') {
                    document.getElementById(streamId.detail).pause();
                }
                streamId.sendData(this.props.id);
                this.state.vid.play();
            } else {
                streamId.sendData('');
                this.state.vid.pause();
            }
        }
    }

    // showPopup = (data) => {
    //     modalService.sendModalMessage({status:true,data: <VideoPopup {...data} />});
    //     // setTimeout(() => {
    //     //     this.videoControl()
    //     // },200);
    // }

    render() {
        const { id, style, src, videoPopup, customPlayer, addVersion, show, setDuration, controls, type } = this.props;
        const { status, videoSrc, showIcon, disable, version } = this.state;
        let videoS = null;
        if (CheckValue(videoSrc)) {
            videoS = addVersion ? videoSrc + version : videoSrc
        }
        const video_icon = <FontAwesomeIcon className={disable ? 'disable' : ''} onClick={videoPopup ? null : this.videoControl} icon={status ? faPlayCircle : faPauseCircle} />;
        const player = customPlayer ?
            <video
                style={{ display: this.state.status || videoPopup ? 'none' : 'inherit' }}
                id={id}
                preload="auto"
                src={videoS}
                controls={controls}
                onPlay={e => this.setState({ status: false })}
                onPause={e => this.setState({ showIcon: true, status: true })}
                onLoadedMetadata={e => {
                    setDuration(e.target.duration);
                    this.setState({ disable: false });
                }
                }
                onLoadStart={e => this.setState({ disable: true })}
                poster={src}
            /> :
            <video autoPlay id={id} src={videoS} poster={src} controls />;
        // const downloads = download?
        //     <div className="download">
        //         <ToolTips showTooltip={true} position='top' message="Download Video"> 
        //             <FontAwesomeIcon icon={faDownload} />
        //         </ToolTips>
        //     </div>:null;
        return (
            <React.Fragment>
                <div className={`videoTag active${show ? (disable ? " disable" : "") : ' displayN'}`} style={style}
                    onMouseEnter={e => this.setState({ showIcon: true })}
                    onMouseMove={e => this.setState({ showIcon: true })}
                    onMouseLeave={e => this.setState({ showIcon: !status ? false : showIcon })}
                // onClick={() => videoPopup?this.showPopup({...this.props, id:id+'_'+id,customPlayer:false,videoPopup:false}):null}
                >
                    {/* {downloads} */}
                    {showIcon && customPlayer && !controls && video_icon}
                    {this.state.status && customPlayer && <Images src={src || (type === 'announcement' ? selectIcon('videoIcon') : selectIcon('streamPlaceholder'))} />}
                    {player}
                </div>
            </React.Fragment>
        )
    }
}

export default StreamingVideo;

StreamingVideo.propTypes = {
    id: PropTypes.string.isRequired,
    style: PropTypes.object,
    src: PropTypes.string,
    videoSrc: PropTypes.string,
    videoPopup: PropTypes.bool.isRequired,
    show: PropTypes.bool.isRequired,
    customPlayer: PropTypes.bool.isRequired,
    controls: PropTypes.bool,
    setDuration: PropTypes.func
}

StreamingVideo.defaultProps = {
    id: 'videoId',
    style: null,
    src: null,
    videoSrc: null,
    videoPopup: false,
    show: true,
    customPlayer: true,
    controls: false,
    setDuration: () => null
}